import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useAppDispatch } from 'src/app/store';
import {
  useTripsCreatesListQuery,
  useTripsEventsListQuery,
  useTripsLocationsListQuery,
  useTripsUpdatesListQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { useAuth } from 'src/features/auth/useAuth';

import { TripSummaryRouteParams } from '../routes';
import { tripSummarySlice } from './tripSummary.slice';

export function useTripSummaryRouteViewModel() {
  const auth = useAuth();
  const dispatch = useAppDispatch();

  const { tripId } = useParams<TripSummaryRouteParams>();
  const { data, isLoading, isFetching, error } = useTripsEventsListQuery({
    'Organization-ID': auth.currentOrganizationId || '',
    id: tripId || '',
  });

  const createEventRequestState = useTripsCreatesListQuery({
    'Organization-ID': auth.currentOrganizationId || '',
    id: tripId || '',
  });

  const updateEventRequestState = useTripsUpdatesListQuery({
    'Organization-ID': auth.currentOrganizationId || '',
    id: tripId || '',
  });

  const tripLocationsRequestState = useTripsLocationsListQuery({
    'Organization-ID': auth.currentOrganizationId || '',
    id: tripId || '',
  });

  useEffect(() => {
    if (data?.results?.length) {
      dispatch(tripSummarySlice.actions.loadTripEvents(data.results));
    }
  }, [data?.results, dispatch]);

  useEffect(() => {
    if (createEventRequestState?.data?.results?.length) {
      dispatch(
        tripSummarySlice.actions.loadTripCreateEvents(
          createEventRequestState?.data.results
        )
      );
    }
  }, [createEventRequestState?.data?.results, dispatch]);

  useEffect(() => {
    if (updateEventRequestState?.data?.results?.length) {
      dispatch(
        tripSummarySlice.actions.loadTripUpdateEvents(
          updateEventRequestState?.data.results
        )
      );
    }
  }, [updateEventRequestState?.data?.results, dispatch]);

  useEffect(() => {
    if (tripLocationsRequestState?.data?.results?.length) {
      dispatch(
        tripSummarySlice.actions.loadTripLocations(
          tripLocationsRequestState?.data.results
        )
      );
    }
  }, [tripLocationsRequestState?.data?.results, dispatch]);

  return {
    shouldShowLoadingState:
      isLoading ||
      isFetching ||
      createEventRequestState.isLoading ||
      createEventRequestState.isFetching ||
      updateEventRequestState.isLoading ||
      updateEventRequestState.isFetching ||
      tripLocationsRequestState.isLoading ||
      tripLocationsRequestState.isFetching,
    // TODO: Need to break these out and show all errors that occur rather than the first truthy one
    error:
      error ||
      createEventRequestState.error ||
      updateEventRequestState.error ||
      tripLocationsRequestState.error,
    tripId,
  };
}
